import React from 'react';
import _ from 'lodash';

const UseTable = (props) => {
    const [tableData, setData] = React.useState([]);

    const [total, setTotal] = React.useState(0);
    const [curPage, setCurPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);
    const [tableLoading, setLoading] = React.useState(false);
    const [reload, setReload] = React.useState(0);

    const setTableData = (data) => {
        if (!data || !_.isArray(data)) {
            setData([]);
        }

        setData(data.filter((e) => e != null));
    };
    React.useEffect(() => {
        setLoading(true);
        if (props.getList && _.isFunction(props.getList)) {
            props.getList(setTableData, setTotal, curPage, pageSize).then(() => {
                setLoading(false);
            });
        }
    }, props.deps.concat([curPage, pageSize, reload]));

    React.useEffect(() => {
        setCurPage(1);
    }, props.deps);

    const reloadTable = () => {
        setReload(reload + 1);
    };
    const onPageSizeChange = (value, _pageSize) => {
        setCurPage(1);
        setPageSize(_pageSize);
    };

    const onPageBarChange = (event, value, _pageSize) => {
        setCurPage(value);
        setPageSize(_pageSize);
    };

    const editRowData = (index, type, value) => {
        const copyList = _.cloneDeep(tableData);
        copyList[index][type] = value;
        setTableData(copyList);
    };

    const asyncEditRowData = (index, type, value, asyncCall) => {
        const oriValue = tableData[index][type];

        editRowData(index, type, value);

        asyncCall(tableData[index], value).then((data) => {
            if (data.code !== 0) {
                editRowData(index, type, oriValue);
            }
        });
    };

    return {
        pageBarAttr: {
            value: curPage,
            pageSize,
            totalSize: total,
            pageSizeList: [10, 20, 30, 40],
            onChange: onPageBarChange,
            onPageSizeChange,
            showPageJudge: false,
        },
        data: tableData,
        setTableData,
        setTotal,
        editRowData,
        asyncEditRowData,
        tableLoading,
        reloadTable,
    };
};

export default UseTable;
